import { createReducer, on } from '@ngrx/store';
import { setLogo } from './logo.actions';
import { LogoConfig } from '@/app/_core/domain/models/logo/logo.model';

export interface LogoState {
  logo: LogoConfig;
}

export const initialLogoState: LogoState = {
  logo: null
};

export const reducer = createReducer<LogoState>(
  initialLogoState,
  on(setLogo, (state, action) => ({
    ...state,
    logo: action.payload.logo
  }))
);
